/**
 * آدرسِ وبی که کاربر می‌نویسه.
 *
 * هیچ‌کس «https://» تایپ نمی‌کنه. فرمِ پیشنهادِ رخداد این رو **اجباری** کرده
 * بود و نتیجه‌ش این بود که کاربر `x.com` می‌نوشت، دکمه‌ی ذخیره خاموش می‌موند و
 * هیچ اتفاقی نمی‌افتاد — از بیرون دقیقاً شبیهِ گیر کردنِ فرم.
 *
 * پس پروتکل رو خودمون می‌ذاریم و اعتبارسنجی روی همون شکلِ کاملِ‌شده انجام
 * می‌شه. چیزی که واقعاً آدرس نیست («سلام»، متنِ دارای فاصله) همچنان رد می‌شه.
 */

/** `x.com` → `https://x.com`. آدرسی که خودش پروتکل داره دست نمی‌خوره. */
export function normalizeUrl(raw?: string | null): string {
  const s = (raw ?? '').trim();
  if (!s) return '';
  return /^[a-z][a-z0-9+.-]*:\/\//i.test(s) ? s : `https://${s}`;
}

/**
 * شکلِ ظاهری قابلِ قبوله؟ دستِ‌کم یه نقطه و بدونِ فاصله.
 *
 * فقط ظاهر — درست بودنِ خودِ آدرس رو ادمین موقعِ بررسی چک می‌کنه.
 */
export function looksLikeUrl(raw?: string | null): boolean {
  return /^https?:\/\/[^\s.]+\.[^\s]{2,}$/i.test(normalizeUrl(raw));
}

/**
 * `https://www.oaggao.ca/events/art-talk-3/` → `oaggao.ca`
 *
 * برای جایی که خودِ نشانی خیلی بلنده و آنچه واقعاً به کار می‌آد «کجا می‌بردم؟»
 * است — نه مسیرِ کامل. عمداً `new URL` نیست: ورودی می‌تونه ناقص باشه و یه
 * `throw` وسطِ رندرِ فهرست، کلِ صفحه رو می‌بره.
 */
export const domainOf = (url?: string | null): string => {
  if (!url) return '';
  return url.replace(/^https?:\/\//, '').replace(/^www\./, '').replace(/\/.*$/, '');
};
